import React, { useState, useMemo } from 'react';
import { Table, Button, Form, Pagination, Row, Col } from 'react-bootstrap';
import { Localidad } from '../../../../../service/types/types';
import LocalidadModal from '../../predioPrograma/modals/localidad.modal';

type LocalidadTableProps = {
  localidades: Localidad[];
  onSave: (isOk: boolean) => void;
  onGo: (lat: number, lng: number) => void;
};

export default function LocalidadTable({ localidades, onSave, onGo }: LocalidadTableProps) {
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5; // 👈 cantidad de filas por página

  // Filtrar localidades según búsqueda
  const filteredLocalidades = useMemo(() => {
    return localidades.filter((loc) =>
      [loc.name].some((field) =>
        field?.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [localidades, search]);

  // Calcular paginación
  const totalPages = Math.ceil(filteredLocalidades.length / rowsPerPage);
  const paginatedLocalidades = filteredLocalidades.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div style={{ height: '50vh', overflowY: 'auto', padding: '1rem' }}>
      <div className="p-3">
        <Row>
          <Col className="d-flex align-items-center"><h4>Localidades</h4></Col>
          <Col className="d-flex justify-content-end">
            <LocalidadModal onSave={onSave}/>
          </Col>
        </Row>
      </div>
      {/* 🔎 Buscador */}
      <Form.Control
        type="text"
        placeholder="Buscar por nombre o región..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage(1); // resetear a primera página al buscar
        }}
        className="mb-3"
      />

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Nombre</th>
            <th style={{ width: '220px' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {paginatedLocalidades.map((localidad) => (
            <tr key={localidad.id}>
              <td>{localidad.name}</td>
              <td>
                <Button
                  variant="info"
                  size="sm"
                  className="me-2"
                  onClick={() =>
                    onGo(
                      localidad.location.coordinates[1],
                      localidad.location.coordinates[0]
                    )
                  }
                >
                  Ir
                </Button>
                <LocalidadModal onSave={onSave} isUpdate={true} localidad={localidad} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* 📄 Paginación */}
      <Pagination>
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        />
        {[...Array(totalPages)].map((_, idx) => (
          <Pagination.Item
            key={idx + 1}
            active={idx + 1 === currentPage}
            onClick={() => setCurrentPage(idx + 1)}
          >
            {idx + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        />
      </Pagination>
    </div>
  );
}